// extracted by mini-css-extract-plugin
export default {"body":"stat-card_body__D1e+N","row":"stat-card_row__72i1o","value":"stat-card_value__2R8IU"};